import React from 'react'
import { Form } from 'semantic-ui-react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import ModalTransitStockArrival from './ModalTransitStockArrival'
import "./TransitStockArrivalsModifier.css"

const TransitStockArrivalsModifier =
({
    dateRange,
    disabled,
    simulationTransitStockArrivals,
    loadSimulationData,
})=>{
    const { t } = useTranslation()
    const { sim_inputs="" } = loadSimulationData[0] || {}

    const arrivalsCount = loadSimulationData.length
        ? (sim_inputs.transit_stock_arrivals || []).length
        : simulationTransitStockArrivals.length

    return(
        <Form.Field>
            <label
                className="field-title transit-stock-arrivals-label">
                <span className="transit-stock-arrivals-title">{t("simulation.transitStockArrivals")}</span>
                {arrivalsCount > 0 && <span className="transit-stock-arrivals-count">{`(${arrivalsCount})`}</span>}
            </label>
            <ModalTransitStockArrival
                dateRange={dateRange}
                disabled={disabled}
                />
        </Form.Field>
    )
}

TransitStockArrivalsModifier.propTypes = {
    dateRange: PropTypes.object,
    disabled: PropTypes.bool,
    simulationTransitStockArrivals: PropTypes.array,
    loadSimulationData: PropTypes.array,
}

const mapStateToProps = (state)=>({
    simulationTransitStockArrivals: state.analytics.simulationTransitStockArrivals,
    loadSimulationData: state.analytics.loadSimulationData,
})

export default connect(mapStateToProps, {})(TransitStockArrivalsModifier)
